import * as THREE from "three";
import { FontLoader } from "three/examples/jsm/loaders/FontLoader.js";
import { TTFLoader } from "three/examples/jsm/loaders/TTFLoader.js";
import { TextGeometry } from "three/examples/jsm/geometries/TextGeometry.js";
import GlobalColorSingleton from "./GlobalColor";
class Letter3D {
  constructor() {
    console.log(
      "DEFAULT_COLOR from letter 3d",
      GlobalColorSingleton.color.toString(16)
    );
    const loader = new FontLoader();
    loader.load("font/json/optimer_regular.typeface.json", (font) => {
      this.font = font;
      // this.textMaterial = new THREE.MeshPhongMaterial({
      //   color: GlobalColorSingleton.color,
      //   shininess: 100,
      //   specular: 0x222222,
      // });
    });
  }
  set(letter, size = 30, height = 3) {
    let textGeometry = new TextGeometry(letter, {
      font: this.font,
      height: height,
      size: size,
      curveSegments: 20,
      bevelThickness: 1,
      bevelSize: 1,
      bevelEnabled: true,
    });

    // get the center of the geometry
    textGeometry.computeBoundingBox();
    let centerOffset =
      -0.5 * (textGeometry.boundingBox.max.x - textGeometry.boundingBox.min.x);
    textGeometry.translate(centerOffset, 0, 0);
    //set bottom of text to 0
    // let bottomOffset =
    //   -0.5 * (textGeometry.boundingBox.max.y - textGeometry.boundingBox.min.y);
    // textGeometry.translate(0, bottomOffset, 0);

    const textMaterial = new THREE.MeshPhongMaterial({
      color: GlobalColorSingleton.color,
      shininess: 100,
      specular: 0x222222,
    });

    textMaterial.color.setHex(GlobalColorSingleton.color);
    let text3d = new THREE.Mesh(textGeometry, textMaterial);
    text3d.castShadow = true;
    text3d.receiveShadow = true;
    return text3d;
  }
}

export default new Letter3D();
